import React, { useState, useEffect } from "react";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Control } from "react-hook-form";
import { projectsAPI } from "@/api/projects";
import { Project } from "@/types";
import { Loader2 } from "lucide-react";

type ProjectSelectorProps = {
  control: Control<any>;
};

const ProjectSelector: React.FC<ProjectSelectorProps> = ({ control }) => {
  const [projects, setProjects] = useState<{ id: string; name: string }[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch projects from the API
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        setIsLoading(true);
        const data = await projectsAPI.getProjects();
        // Map the data to simplified format for the dropdown, excluding completed projects
        const mappedProjects = data
          .filter(project => project.status !== 'completed')
          .map(project => ({
            id: project.id,
            name: project.name
          }));
        setProjects(mappedProjects);
      } catch (error) {
        
      } finally {
        setIsLoading(false);
      }
    };

    fetchProjects();
  }, []);

  return (
    <FormField
      control={control}
      name="projectId"
      render={({ field }) => (
        <FormItem>
          <FormLabel className="text-sm text-muted-foreground mb-1">Proje</FormLabel>
          <Select onValueChange={field.onChange} defaultValue={field.value}>
            <FormControl>
              <SelectTrigger className="bg-background">
                {isLoading ? (
                  <div className="flex items-center">
                    <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                    <span>Yükleniyor...</span>
                  </div>
                ) : (
                  <SelectValue placeholder="Proje seçin" />
                )}
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {projects.map(project => (
                <SelectItem key={project.id} value={project.id}>{project.name}</SelectItem>
              ))}
              {projects.length === 0 && !isLoading && (
                <div className="py-2 px-4 text-sm text-muted-foreground">
                  Proje bulunamadı
                </div>
              )}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default ProjectSelector;
